import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/interactive/InteractiveExperience.tsx");
